import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@/components/ui/form';
import { ArrowRight, Lock, LockOpen, Mail, User } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { TextField } from '@/components/text-field';
import { PasswordStrength } from '@/components/password-strength';
import { CheckboxField } from '@/components/checkbox-field';
import { TermsAndConditionsDialog } from '@/routes/_layout/sign-up/-components/terms-and-conditions-dialog';
import { PrivacyPolicyDialog } from '@/routes/_layout/sign-up/-components/privacy-policy-dialog';
export const SignUpForm = ({ form, onSubmit, isPending }) => {
    const { t } = useTranslation();
    const [showPassword, onTogglePassword] = React.useState(false);
    const [showConfirmPassword, onToggleConfirmPassword] = React.useState(false);
    const password = form.watch('password');
    return (<Form {...form}>
            <form className="space-y-4" onSubmit={form.handleSubmit(onSubmit)} noValidate>
                <div className="flex space-x-2">
                    <TextField control={form.control} name="firstName" label={t('first_name')} placeholder="John" autoComplete="given-name" className="w-full" startIcon={<User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"/>} disabled={isPending}/>
                    <TextField control={form.control} name="lastName" label={t('last_name')} placeholder="Doe" autoComplete="family-name" className="w-full" startIcon={<User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"/>} disabled={isPending}/>
                </div>

                <TextField control={form.control} name="email" label={t('email')} type="email" placeholder="you@coffee.co" className="w-full" autoComplete="email" startIcon={<Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"/>} disabled={isPending}/>

                <div className="flex flex-col space-y-2 w-full">
                    <div className="flex flex-col space-y-2 w-full">
                        <TextField control={form.control} name="password" label={t('password')} className="w-full" type={showPassword ? 'text' : 'password'} autoComplete="new-password" placeholder="••••••••" endIcon={<Button variant="ghost" size="icon" type="button" onClick={(event) => {
                event.preventDefault();
                onTogglePassword((prevState) => !prevState);
            }} className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground">
                                    {showPassword ? <Lock className="h-4 w-4"/> : <LockOpen className="h-4 w-4"/>}
                                </Button>} disabled={isPending}/>
                        <PasswordStrength value={password}/>
                    </div>

                    <TextField control={form.control} name="confirmPassword" label={t('confirm_password')} className="w-full" type={showConfirmPassword ? 'text' : 'password'} placeholder="••••••••" endIcon={<Button variant="ghost" size="icon" type="button" onClick={(event) => {
                event.preventDefault();
                onToggleConfirmPassword((prevState) => !prevState);
            }} className="absolute right-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground">
                                {showConfirmPassword ? <Lock className="h-4 w-4"/> : <LockOpen className="h-4 w-4"/>}
                            </Button>} disabled={isPending} autoComplete="new-password"/>
                </div>

                <div className="flex items-start gap-2">
                    <CheckboxField disabled={isPending} control={form.control} name="acceptedTerms" label={<React.Fragment>
                                I agree to the
                                <TermsAndConditionsDialog />
                                and
                                <PrivacyPolicyDialog />.
                            </React.Fragment>}></CheckboxField>
                </div>

                <Button type="submit" className="w-full" disabled={isPending}>
                    Create account
                    <ArrowRight className="ml-2 h-4 w-4"/>
                </Button>
            </form>
        </Form>);
};
SignUpForm.displayName = 'SignUpForm';
